<template>
  <div class="follow-suggestion-card" v-if="customer?.name_slug">
    <div class="follow-suggestion-card__body text-center">
      <NuxtLink
        :to="!customer?.lawyer
          ? {
              name: 'oglas-svi-oglasi-customer-id',
              params: {
                customer: $srbTolat.srbTolat(customer?.name),
                id: customer?.id
              }
            }
          : {
              name: 'tezga-lawyername-page',
              params: {
                lawyername: customer?.name_slug,
                page: 1
              }
            }"
      >
        <div class="follow-suggestion-card__avatar-wrap mx-auto mb-2">
          <img
            v-if="customer.logo"
            :src="customer.logo"
            :alt="customer.lawyer_name || customer.name"
            class="follow-suggestion-card__avatar"
          >

          <div
            v-else
            class="follow-suggestion-card__avatar follow-suggestion-card__avatar--placeholder d-flex align-items-center justify-content-center"
          >
            {{ getInitials(customer.name) }}
          </div>
        </div>

        <h3 class="follow-suggestion-card__name mb-1">
          {{ customer.lawyer_name || customer.name }}
        </h3>

        <div
          v-if="customer.lawyer_name && customer.lawyer_name !== customer.name"
          class="follow-suggestion-card__full-name mb-1"
        >
          {{ customer.name }}
        </div>

        <div class="follow-suggestion-card__username mb-3">
          {{ getUsername(customer.email) }}
        </div>
      </NuxtLink>

      <button
        type="button"
        class="btn follow-suggestion-card__button"
        :class="isFollowing ? 'unfollow-btn' : 'follow-btn'"
        :disabled="loadingIds.includes(customer.id)"
        @click="isFollowing ? unfollowCustomer(customer.id) : followCustomer(customer.id)"
      >
        <span v-if="loadingIds.includes(customer.id)"></span>
        <span v-else>{{ isFollowing ? 'Otprati' : 'Prati' }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useCustomerStore } from '~/stores/customer'
import { useCustomerLoginStore } from '~/stores/login/customer'

const props = defineProps({
  customer: {
    type: Object,
    default: () => ({})
  }
})

const customerStore = useCustomerStore()
const useStore = useCustomerLoginStore()

const loadingIds = ref([])

function getUsername(email) {
  if (!email) return ''
  return '@' + email.split('@')[0]
}

function getInitials(name) {
  if (!name) return ''

  const parts = name.trim().split(/\s+/).filter(Boolean)

  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase()
  }

  const first = parts[0].charAt(0)
  const last = parts[parts.length - 1].charAt(0)

  return `${first}${last}`.toUpperCase()
}

const isFollowing = computed(() => {
  const authCustomerId = Number(useStore?.customer?.id)

  if (!authCustomerId || !props.customer?.followers?.length) {
    return false
  }

  return props.customer.followers.some(
    follow => Number(follow.id) === authCustomerId
  )
})

const ensureFollowersArray = () => {
  if (!Array.isArray(props.customer.followers)) {
    props.customer.followers = []
  }
}

async function followCustomer(customerId) {
  if (loadingIds.value.includes(customerId)) {
    return
  }

  loadingIds.value.push(customerId)

  try {
    const { data } = await customerStore.followCustomer(customerId)

    if (data?.following) {
      ensureFollowersArray()

      const authCustomerId = Number(useStore?.customer?.id)
      const alreadyExists = props.customer.followers.some(
        follow => Number(follow.id) === authCustomerId
      )

      if (!alreadyExists && authCustomerId) {
        props.customer.followers.push({
          id: authCustomerId
        })
      }
    }
  } catch (error) {
    console.error(error)
  } finally {
    loadingIds.value = loadingIds.value.filter(id => id !== customerId)
  }
}

async function unfollowCustomer(customerId) {
  if (loadingIds.value.includes(customerId)) {
    return
  }

  loadingIds.value.push(customerId)

  try {
    const { data } = await customerStore.unfollowCustomer(customerId)

    if (data && data.following === false) {
      ensureFollowersArray()

      const authCustomerId = Number(useStore?.customer?.id)

      props.customer.followers = props.customer.followers.filter(
        follow => Number(follow.id) !== authCustomerId
      )
    }
  } catch (error) {
    console.error(error)
  } finally {
    loadingIds.value = loadingIds.value.filter(id => id !== customerId)
  }
}
</script>

 